import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/appIcons/app-store.svg'
import _imports_1 from '../assets/images/appIcons/google-play.svg'


const _withScopeId = n => (_pushScopeId("data-v-f571fa0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-8" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "custom-gradient text-center text-2xl not-italic font-semibold md:pb-2 md:mb-6 md:mt-16 md:flex-grow md:flex md:items-center md:justify-center sm:text-sm" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex flex-wrap sm:block justify-around m-1" }
const _hoisted_7 = { class: "paymentBoxRight relative" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "mt-4 text-center" }
const _hoisted_10 = { class: "flex mt-4 justify-around" }
const _hoisted_11 = { class: "mt-14 text-center" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "w-60 p-3 br8" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Apple Store",
  src: _imports_0
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "w-60 p-3 br8" }
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Google Play",
  src: _imports_1
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BookingDetail = _resolveComponent("BookingDetail")!
  const _component_AddPlayers = _resolveComponent("AddPlayers")!
  const _component_BorderButton = _resolveComponent("BorderButton")!
  const _component_PopUpLight = _resolveComponent("PopUpLight")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.booking.type?.code == _ctx.bookingType.MATCH)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("match_details")), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("booking_details")), 1))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.booking.id !== undefined)
        ? (_openBlock(), _createBlock(_component_BookingDetail, {
            booking: _ctx.booking,
            showChat: _ctx.user.id !== 0,
            showResourceName: true,
            onBookingCancelled: _ctx.handleBookingCancelled,
            showAddCalendar: true,
            key: _ctx.refreshKey
          }, null, 8, ["booking", "showChat", "onBookingCancelled"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.booking.id !== undefined)
          ? (_openBlock(), _createBlock(_component_AddPlayers, {
              bookingData: _ctx.booking,
              mode: _ctx.mode,
              onSetUpCompleted: _ctx.openPaymentMethodHandler,
              key: _ctx.refreshKey
            }, null, 8, ["bookingData", "mode", "onSetUpCompleted"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.openPaymentPopUp)
          ? (_openBlock(), _createBlock(_component_PopUpLight, {
              key: 0,
              showOkButton: true,
              showClose: false,
              onClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closePaymentMethod()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.alreadySigned), 1),
                    _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.payMsg), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_BorderButton, {
                        onClicked: _ctx.pay,
                        text: _ctx.$t('pay')
                      }, null, 8, ["onClicked", "text"]),
                      _createVNode(_component_BorderButton, {
                        onClicked: _ctx.notPay,
                        text: _ctx.$t('continue_without_paying')
                      }, null, 8, ["onClicked", "text"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.openSoccerPopUp)
          ? (_openBlock(), _createBlock(_component_PopUpLight, {
              key: 0,
              showOkButton: true,
              showClose: false,
              onClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeSoccerpopup()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("download_app_for_match")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("a", {
                        href: _ctx.appLink.APPSTORE,
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, _hoisted_16, 8, _hoisted_14)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("a", {
                        href: _ctx.appLink.GOOGLEPLAY,
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, _hoisted_20, 8, _hoisted_18)
                    ])
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}